<template>
	<div class="course">
		<div class="title color-black-gray1">我的DFC歷程</div>
		<div class="badges-box layout-row">
			<div class="badge layout-column layout-hv-center pointer" @click="showBadge()">
				<img src="../../../assets/logo.svg" alt="">
				<div class="label layout-row layout-hv-center">DFC挑戰</div>
			</div>
			<div class="badge layout-column layout-hv-center pointer" @click="showBadge()">
				<img src="../../../assets/logo.svg" alt="">
				<div class="label layout-row layout-hv-center">DFC挑戰</div>
			</div>
			<div class="badge layout-column layout-hv-center pointer" @click="showBadge()">
				<img src="../../../assets/logo.svg" alt="">
				<div class="label layout-row layout-hv-center">DFC挑戰</div>
			</div>
			<div class="badge layout-column layout-hv-center pointer" @click="showBadge()">
				<img src="../../../assets/logo.svg" alt="">
				<div class="label layout-row layout-hv-center">DFC挑戰</div>
			</div>
		</div>
		<el-dialog title="" :visible.sync="isBadgeShow">
			<Badge></Badge>
		</el-dialog>
	</div>
</template>

<script>
import Badge from "./Badge";

export default {
	data() {
		return {
			isBadgeShow: false
		};
	},
	computed: {},
	methods: {
		showBadge(selectedBadge) {
			this.isBadgeShow = true;
		}
	},
	created() { },
	mounted() { },
	components: {
		Badge
	}
};
</script>

<style lang="scss">
.course {
	padding: 15px 17px 33px 17px;
	background-color: #f6f7f8;

	.title {
		font-size: 18px;
		font-weight: 500;
		margin-bottom: 27px;
	}

	.badges-box {
		margin-left: 10px;

		.badge {
			margin-right: 45px;

			img {
				width: 80px;
				height: 80px;
				margin-bottom: 18px;
			}

			.label {
				font-size: 14px;
				font-weight: 500;
			}
		}
	}

	.el-dialog {
		width: 800px;
	}
}
</style>